import request from '@/utils/request'

let UroleApi = {

  /*角色管理列表*/
  list(data) {
    return request._post('/shop/plus.urole.Index/index', data);
},
/*添加角色管理*/
add(data) {
    return request._post('/shop/plus.urole.Index/add', data);
},
/*修改角色管理*/
edit(data) {
    return request._post('/shop/plus.urole.Index/edit', data);
},
editAuth(data) {
    return request._post('/shop/plus.urole.Index/editAuth', data);
},
/*删除角色管理*/
del(data) {
    return request._post('/shop/plus.urole.Index/del', data);
},
/*角色管理详情*/
detail(data) {
  return request._post('/shop/plus.urole.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.urole.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.urole.Setting/getSetting', data, errorback);
    },
}
export default UroleApi;



// WEBPACK FOOTER //
// ./src/api/urole.js